<template>
    <TimePhase></TimePhase>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const TimePhase = defineAsyncComponent(() =>
    import("../../components/Purchasing/TimePhase/TimePhase.vue")
);

export default {
    name: "Project_TimePhase",
    components: { TimePhase, AuthLayout },
};
</script>
